import React from 'react';

const VoxogramTheme = {
  headerLogo: {
    src: '/themes/theme/voxogram/logo.png',
    alt: 'Voxogram',
  },
  darkLogo: {
    src: '/themes/theme/voxogram/logo.png',
    alt: 'Voxogram',
  },
  headerStyle: {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #df0098',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  isLightOnDark: false,
  title: 'voxogram',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="80" src="/themes/theme/voxogram/logo.png" alt="Voxogram" />
    </div>
  ),
  shareSite: 'https://app.voxogram.com',
  mobileRedirectLink: 'www.voxogram.com',
  facebookClientId: '1517444368400108',
  disableIntercom: true,
  isFullWhiteLabel: true,
  disableHelpLinks: true,
  hideCopyrightNotices: true,
  hideSignup: true,
  hideInfluencerImportExport: true,
  platformName: 'voxogram',
  termsAndConditionsLink: 'https://www.voxogram.com/terms-and-conditions',
};

export default VoxogramTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/voxogram.js
 **/